<template>
  <help-dialog title="Generate Cards">
    <template #default>
      <h3 class="mb-1">Generate cards</h3>
      <p class="text-grey-darken-3">
        AI can generate cards for each step in the workflow.
        Select which card types to be generated. <template v-if="!settings">The
          card types are configurable under
          <a href="?action=workflowSettings&tab=CARDS" class="text-blue-accent-4"><b>workflow settings</b></a> (<v-icon icon="mdi-cog-outline" size="x-small"></v-icon> top right).
        </template>
        <br ><br />
        When configuring card types, both the name and description are important,
        as they are used when generating cards with AI. For example,
        <br />
        <br />
        <u>Card Type:</u>
        <br />
        <b>User Story</b>
        <br />
        <br />
        <u>Description:</u>
        <br />
        <b>A user story describes a feature of a software system used in this step of the process</b>
        <br />
      </p>
    </template>
  </help-dialog>
</template>

<script setup>
import HelpDialog from '@/components/HelpDialog.vue'

defineProps({
  settings: {
    type: Boolean,
    default: false
  }
})
</script>
